var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "IONIcon/S/search/circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.8906 2C7.10086 2 2.39062 6.71023 2.39062 12.5C2.39062 18.2898 7.10086 23 12.8906 23C18.6804 23 23.3906 18.2898 23.3906 12.5C23.3906 6.71023 18.6804 2 12.8906 2ZM17.8841 17.4935C17.7201 17.6575 17.4976 17.7496 17.2656 17.7496C17.0337 17.7496 16.8112 17.6575 16.6471 17.4935L14.3043 15.1513C13.3145 15.8323 12.106 16.1189 10.9158 15.9548C9.7256 15.7907 8.6397 15.1878 7.87119 14.2643C7.10267 13.3407 6.70702 12.1634 6.76187 10.9632C6.81672 9.76298 7.31812 8.62661 8.16768 7.77705C9.01723 6.9275 10.1536 6.4261 11.3538 6.37124C12.554 6.31639 13.7314 6.71204 14.6549 7.48056C15.5784 8.24908 16.1813 9.33498 16.3455 10.5252C16.5096 11.7154 16.2229 12.9239 15.5419 13.9137L17.8841 16.2565C18.0481 16.4206 18.1402 16.643 18.1402 16.875C18.1402 17.107 18.0481 17.3294 17.8841 17.4935Z",
    fill: "#0065FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.6406 14.5C13.4356 14.5 14.8906 13.0449 14.8906 11.25C14.8906 9.45507 13.4356 8 11.6406 8C9.8457 8 8.39062 9.45507 8.39062 11.25C8.39062 13.0449 9.8457 14.5 11.6406 14.5Z",
    fill: "#0065FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchB);
export default __webpack_public_path__ + "static/media/search-b.13406bf458ae403956ea426a0fb5b36e.svg";
export { ForwardRef as ReactComponent };